<template>
  <div v-show="showNotification(getActiveDeviceDaysToExpire)" class="content-container">
    <div class="message">
      <span class="days">{{ daysLeft }}</span>
      <!-- <span>access <br />days left</span> -->
      <span>days left for uninterrupted electricty</span>
      <span class="dot dot--left"></span>
      <span class="dot dot--right"></span>
    </div>
    <!-- <button @click="show = false" type="button" class="info">Click to hide</button> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {},
  computed: {
    ...mapGetters(["getAssignedDevices", "getActiveDeviceDaysToExpire"])
  },
  data() {
    return {
      show: false,
      daysLeft: 1000
    };
  },
  methods: {
    showNotification(num) {
      if (!num) return false;
      const res = Math.round(num);
      if (res <= 0) {
        this.daysLeft = 0;
        return true;
      }
      if (res < 6 && res > 0) {
        this.daysLeft = res;
        return true;
      }
      return false
    },
    // async fetchDevicesDaysLeft() {
    //   const HTTP = this.$httpUtils.NotificationHTTP;
    //   let devices = this.getAssignedDevices;
    //   if (!devices || devices.length < 1) return;
    //   // @todo: uncomment next line, and pass all devices
    //   // get daysLeft array, loop through and show for devices
    //   // devices = devices.join(",");
    //   HTTP.get(`configuration/${devices[0]}`)
    //     .then(res => {
    //       // @todo: pass all devices ^^ to endpoint and loop through here
    //       this.showNotification(res.data.response.daysToExpire);
    //       // {deviceId, daysToExpire}
    //     })
    //     .catch(error => {
    //       console.log("error", error);
    //     });
    // }
  },
  mounted() {
    // this.showNotification();
  }
};
</script>

<style scoped>
.content-container {
  position: absolute;
  width: 110px;
  text-align: center;
  z-index: 9999;
  top: 0;
  right: 0;
  margin: 20px;
  margin-top: 60px;

  --shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px,
    rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
  --background: linear-gradient(
    180deg,
    rgba(242, 242, 242, 1) 35%,
    rgba(201, 201, 201, 1) 100%
  );
}

.message {
  background: rgb(242, 242, 242);
  background: var(--background);
  /* box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px; */
  box-shadow: var(--shadow);
  background: red;
  color: white;
  padding: 10px;
  font-size: 14px;
  border-radius: 10px;
  position: relative;
}

.days {
  font-size: 35px;
  display: block;
  font-weight: bold;
}

.info {
  /* background: rgb(242, 242, 242); */
  background: var(--background);
  box-shadow: var(--shadow);
  border: 0;
  /* background: red; */
  /* color: white; */
  border-radius: 30px;
  padding: 10px;
  font-size: 12px;
  margin-top: 10px;
}

.dot {
  display: block;
  width: 8px;
  height: 24px;
  box-shadow: var(--shadow);
  /* box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px; */
  background: var(--background);
  /* background: red; */
  position: absolute;
  border-radius: 10px;
  top: -15px;
}

.dot--left {
  left: 20px;
}

.dot--right {
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Notifications/DaysLeft.vue